<template lang="html">
    <div class="">
        <span class="info small">Availability</span>

        <span class="info player white" v-if="availableTimes.length < 1" style="font-size: 16px"
            >Currently unavailable</span
        >

        <div class="availabilityItems AvaialbelavailabilityItems">
            <availability-item
                @updateAvailability="updateTime"
                @removeAvailability="removeTime"
                v-for="(time, index) in availableTimes"
                :key="index"
                :time="time"
            />
        </div>

        <form class="form3" @submit.prevent="saveSettings" v-if="formOpen">
            <div class="group avialableGroup">
                <div class="formGroup third">
                    <vue-timepicker
                        class="timePicker"
                        v-model="form.times[0].start"
                        :minute-interval="15"
                    ></vue-timepicker>
                </div>
                <div class="formGroup third">
                    <vue-timepicker
                        class="timePicker"
                        v-model="form.times[0].end"
                        :minute-interval="15"
                    ></vue-timepicker>
                </div>
                <div class="formGroup third">
                    <button @click.prevent="saveTime" class="button" type="button" name="button">
                        Confirm
                    </button>
                </div>
            </div>

            <has-error class="info error" :form="form" field="times"></has-error>
        </form>

        <div v-else>
            <button
                :disabled="form.busy"
                @click.prevent="formOpen = true"
                class="button dark mb10 left"
                type="button"
                name="button"
            >
                Add availability
                <plus-icon class="icon" />
            </button>

            <button
                v-if="availableTimes.length > 0"
                :disabled="form.busy"
                @click.prevent="removeAllAvailability"
                class="button red"
                type="button"
                name="button"
            >
                Remove availability
            </button>
        </div>
    </div>
</template>

<script>
import { Form, HasError } from "vform";
import { PlusIcon } from "vue-feather-icons";
import AvailabilityItem from "@/components/Pro/Lessons/availability-item";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
export default {
    name: "availability-list",
    components: { VueTimepicker, HasError, PlusIcon, AvailabilityItem },
    computed: {
        start() {
            return this.$date(this.$route.params.start).format("D MMM YYYY");
        },
        end() {
            return this.$date(this.$route.params.end).format("D MMM YYYY");
        },
    },
    data() {
        return {
            formOpen: false,
            availableTimes: [],
            form: new Form({
                start: this.start,
                end: this.end,
                times: [{ start: "12:00", end: "13:00" }],
            }),
        };
    },
    created() {
        this.getAvailability();
    },
    methods: {
        addTime($time) {
            this.availableTimes.push($time);
        },
        updateTime($time) {
            var index = this.availableTimes.findIndex((availability) => {
                return availability.id == $time.id;
            });
            this.availableTimes.splice(index, 1, $time);
        },
        removeTime($time) {
            var index = this.availableTimes.findIndex((availability) => {
                return availability.id == $time.id;
            });
            this.availableTimes.splice(index, 1);

            this.$emit("onAvailability", this.availableTimes.length);
        },
        removeAllAvailability() {
            this.$confirm(
                "This will remove all availability from " +
                    this.start +
                    " to " +
                    this.end +
                    ". Are you sure you want to do this?",
                () => {
                    this.form.start = this.start;
                    this.form.end = this.end;
                    this.form.delete("/availability").then(() => {
                        this.availableTimes = [];
                        this.$notify({
                            duration: 3000,
                            text: "Your availability and lessons have been removed!",
                        });
                        this.$emit("availabilityRemoved");
                    });
                },
            );
        },
        saveTime() {
            this.form.start = this.start;
            this.form.end = this.end;
            this.form.post("/availability").then((response) => {
                this.formOpen = false;

                this.$emit("onAvailability", 1);

                response.data.forEach((item) => {
                    item["times"] = [{}];
                    item["times"][0].start = item.start;
                    item["times"][0].end = item.end;
                });

                this.availableTimes = response.data;
                this.$notify({
                    duration: 3000,
                    text: "Your availability has been saved!",
                });
            });
        },
        getAvailability() {
            window.axios
                .get("/availability?start=" + this.start + "&end=" + this.end)
                .then((response) => {
                    if (response.data.availability.length > 0) {
                        this.$emit("onAvailability", response.data.availability.length);
                        response.data.availability.forEach((availability) => {
                            this.availableTimes.push(availability);
                        });
                    }
                });
        },
    },
};
</script>

<style lang="scss">
.avialableGroup {
    display: flex;
    .formGroup {
        margin-right: 10px;
        margin-bottom: 10px;
        flex: 1;
        &:last-of-type {
            margin-right: 0px;
        }
    }
}
.AvaialbelavailabilityItems {
    margin-bottom: 20px;
}
.vue__time-picker input[type="text"] {
    background: white !important;
    height: 52px !important;
    min-height: 52px !important;
}
</style>
